import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXIconModule } from '../icon/icon.module';
import { UBXAccordionComponent } from './accordion.component';
import { UBXAccordionBodyComponent } from './body/accordion-body.component';
import { UBXAccordionHeadComponent } from './head/accordion-head.component';
import { UBXAccordionRowComponent } from './row/accordion-row.component';

const Imports = [
    UBXIconModule,
];
const Module = [
    UBXAccordionComponent,
    UBXAccordionBodyComponent,
    UBXAccordionHeadComponent,
    UBXAccordionRowComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXAccordionModule {}
